import { graphql,
  requestSubscription } from 'react-relay';

export const FinishedDuplicateDocumentSubscriptionQuery = graphql`
  subscription FinishedDuplicateDocumentSubscription($filter: BaseSubscriptionInput!) {
    finishedDuplicateDocumentSubscription(filter: $filter) {
      sequence
      id
      step
      document
      widgets
      globalVariables
    }
  }
`;

export default (environment) => {
  return requestSubscription(
    environment,
    {
      subscription: FinishedDuplicateDocumentSubscriptionQuery,
      variables: {},
      updater: (
        store,
        { finishedDuplicateDocumentSubscription }
      ) => {
        const { id, step, document, widgets, globalVariables } = finishedDuplicateDocumentSubscription;
        let record = store.get(id);

        if (!record) {
          record = store.create(id, 'duplicateDocument');
        }

        record.setValue(step, 'step');
        record.setValue(document, 'document');
        record.setValue(widgets, 'widgets');
        record.setValue(globalVariables, 'globalVariables');
      },
      onCompleted: () => {},
      onError: error => {
        console.error('SUBSCRIPTION FINISHED DUPLICATE DOCUMENT ERROR:', error.message);
      }
    }
  );
};
